import axios from "axios";

// Thiết lập URL cơ sở cho tất cả các yêu cầu API
const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}/api/auth`;

// Hàm đăng ký
const register = async (userData) => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}/register`, userData);
    return response.data;
  } catch (error) {
    console.error("Registration Error:", error);
    throw error.response.data;
  }
};

// Hàm đăng nhập
const login = async (userData) => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}/login`, userData);
    return response.data;
  } catch (error) {
    console.error("Login Error:", error);
    throw error.response.data;
  }
};

// Hàm đăng xuất
const logout = async () => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}/logout`);
    return response.data;
  } catch (error) {
    console.error("Logout Error:", error);
    throw error.response.data;
  }
};

const authService = {
    login,
    logout,
    register
}

export default authService;
